/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BulkOperationsRequestBody,
    BulkOperationsRequestBodyFromJSON,
    BulkOperationsRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
    Report,
    ReportFromJSON,
    ReportToJSON,
    ReportMap,
    ReportMapFromJSON,
    ReportMapToJSON,
    Reports,
    ReportsFromJSON,
    ReportsToJSON,
} from '../models';

export interface ArchiveReportsRequest {
    project_id: number;
    environment_key: string;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface DeleteReportRequest {
    project_id: number;
    environment_key: string;
    report_key: string;
}

export interface FetchReportRequest {
    project_id: number;
    environment_key: string;
    report_key: string;
}

export interface ListReportsRequest {
    project_id: number;
    environment_key: string;
    per_page?: number;
    page_token?: string;
    page_window?: number;
    sort?: Array<ListReportsSortEnum>;
    archived?: boolean;
    query?: string;
}

export interface ResetResultsRequest {
    project_id: number;
    environment_key: string;
    report_key: string;
}

export interface UnarchiveReportsRequest {
    project_id: number;
    environment_key: string;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

/**
 * no description
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Archive one or more Reports in an Environment of a Project.  This operation corresponds to the `archive_url` in a Reports response. 
     * Archive Reports
     */
    async archiveReportsRaw(requestParameters: ArchiveReportsRequest): Promise<runtime.ApiResponse<ReportMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling archiveReports.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling archiveReports.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling archiveReports.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_key}/reports/archived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportMapFromJSON(jsonValue));
    }

    /**
     * Archive one or more Reports in an Environment of a Project.  This operation corresponds to the `archive_url` in a Reports response. 
     * Archive Reports
     */
    async archiveReports(requestParameters: ArchiveReportsRequest): Promise<ReportMap> {
        const response = await this.archiveReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Permanently delete a Report by key in an Environment of a project  There will be no way to access this data after deletion. If you want to stop seeing a Report without deleting it permanently, try archiving instead. 
     * Delete a Report
     */
    async deleteReportRaw(requestParameters: DeleteReportRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteReport.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling deleteReport.');
        }

        if (requestParameters.report_key === null || requestParameters.report_key === undefined) {
            throw new runtime.RequiredError('report_key','Required parameter requestParameters.report_key was null or undefined when calling deleteReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_key}/reports/{report_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))).replace(`{${"report_key"}}`, encodeURIComponent(String(requestParameters.report_key))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently delete a Report by key in an Environment of a project  There will be no way to access this data after deletion. If you want to stop seeing a Report without deleting it permanently, try archiving instead. 
     * Delete a Report
     */
    async deleteReport(requestParameters: DeleteReportRequest): Promise<void> {
        await this.deleteReportRaw(requestParameters);
    }

    /**
     * Fetch a single Report in an Environment of a Project by its key.  This operation corresponds to the `fetch_report_url` in a Report response. 
     * Fetch a Single Report
     */
    async fetchReportRaw(requestParameters: FetchReportRequest): Promise<runtime.ApiResponse<Report>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchReport.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling fetchReport.');
        }

        if (requestParameters.report_key === null || requestParameters.report_key === undefined) {
            throw new runtime.RequiredError('report_key','Required parameter requestParameters.report_key was null or undefined when calling fetchReport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_key}/reports/{report_key}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))).replace(`{${"report_key"}}`, encodeURIComponent(String(requestParameters.report_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportFromJSON(jsonValue));
    }

    /**
     * Fetch a single Report in an Environment of a Project by its key.  This operation corresponds to the `fetch_report_url` in a Report response. 
     * Fetch a Single Report
     */
    async fetchReport(requestParameters: FetchReportRequest): Promise<Report> {
        const response = await this.fetchReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of Reports for a specific Environment of a project  You can use query parameters to filter/sort the response. 
     * List Reports
     */
    async listReportsRaw(requestParameters: ListReportsRequest): Promise<runtime.ApiResponse<Reports>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listReports.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling listReports.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_key}/reports`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportsFromJSON(jsonValue));
    }

    /**
     * Get a list of Reports for a specific Environment of a project  You can use query parameters to filter/sort the response. 
     * List Reports
     */
    async listReports(requestParameters: ListReportsRequest): Promise<Reports> {
        const response = await this.listReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Resetting the results for a Report will clear all the current results and results will be calculated from this point onwards. Use caution with this operation as there will be no way to access any previous results. 
     * Reset the results for a Report
     */
    async resetResultsRaw(requestParameters: ResetResultsRequest): Promise<runtime.ApiResponse<Report>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling resetResults.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling resetResults.');
        }

        if (requestParameters.report_key === null || requestParameters.report_key === undefined) {
            throw new runtime.RequiredError('report_key','Required parameter requestParameters.report_key was null or undefined when calling resetResults.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_key}/reports/{report_key}/reset-results`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))).replace(`{${"report_key"}}`, encodeURIComponent(String(requestParameters.report_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportFromJSON(jsonValue));
    }

    /**
     * Resetting the results for a Report will clear all the current results and results will be calculated from this point onwards. Use caution with this operation as there will be no way to access any previous results. 
     * Reset the results for a Report
     */
    async resetResults(requestParameters: ResetResultsRequest): Promise<Report> {
        const response = await this.resetResultsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unarchive one or more Reports in an Environment of a Project.  This operation corresponds to the `unarchive_url` in a Reports response. 
     * Unarchive Reports
     */
    async unarchiveReportsRaw(requestParameters: UnarchiveReportsRequest): Promise<runtime.ApiResponse<ReportMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling unarchiveReports.');
        }

        if (requestParameters.environment_key === null || requestParameters.environment_key === undefined) {
            throw new runtime.RequiredError('environment_key','Required parameter requestParameters.environment_key was null or undefined when calling unarchiveReports.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling unarchiveReports.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/environments/{environment_key}/reports/unarchived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"environment_key"}}`, encodeURIComponent(String(requestParameters.environment_key))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportMapFromJSON(jsonValue));
    }

    /**
     * Unarchive one or more Reports in an Environment of a Project.  This operation corresponds to the `unarchive_url` in a Reports response. 
     * Unarchive Reports
     */
    async unarchiveReports(requestParameters: UnarchiveReportsRequest): Promise<ReportMap> {
        const response = await this.unarchiveReportsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListReportsSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    Keyasc = 'key:asc',
    Keydesc = 'key:desc',
    CreatedTimeasc = 'created_time:asc',
    CreatedTimedesc = 'created_time:desc',
    UpdatedTimeasc = 'updated_time:asc',
    UpdatedTimedesc = 'updated_time:desc'
}
